// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/common/components/formatter/producttpl.less
// module id = 1910
// module chunks = 0